<template>
  <div class="tab-bar">
    <router-link
      v-for="tab in tabs"
      :to="tab.link"
      :key="tab.link"
      :class="['tab-link', { active: route.path === tab.link }]"
      >{{ tab.label }}</router-link
    >
  </div>
</template>
  
  <script setup lang="ts" name="TabBar">
import { useRoute } from "vue-router";
// active 状态直接跟随当前路由，刷新 / footer 跳转 / 前进后退都能正确高亮
const route = useRoute();
const tabs = [
  {
    link: "/",
    label: "首页",
  },
  {
    link: "/product",
    label: "产品介绍",
  },
  {
    link: "/platform",
    label: "数字化平台",
  },
  {
    link: "/customization",
    label: "定制化服务",
  },
  {
    link: "/contact",
    label: "联系我们",
  },
];
</script>
  
  <style scoped lang="scss">
.tab-bar {
  width: 100%;
  height: 100%;
  display: flex;
  bottom: 0;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: #ffffff;
  /* padding: 20px; */
  font-size: 17px;
  font-weight: 500;
  font-family: $font-title;
  letter-spacing: 1px;
  color: #333333;
}

.tab-bar a {
  position: relative;
  margin: 0 30px;
  text-decoration: none;
  color: #333;
  padding-bottom: 15px;
  transition: color 0.3s ease;
  // 动画下划线
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    border-radius: 2px;
    background: $accent;
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease;
  }
}

.tab-bar a:hover {
  color: $primary;
  &::after {
    transform: scaleX(0.55);
  }
}

.tab-bar .active {
  color: $primary;
  &::after {
    transform: scaleX(1);
  }
}
</style>